/*
 * File: /src/router/routes/pipelines.js
 * Created Date: Monday August 17th 2020
 * Author: Nicolas Wegener, Roy Collins
 * -----
 * Last Modified: Tuesday, 18th August 2020 11:20:52 am
 * Modified By: Nicolas Wegener (wegenern@gmail.com)
 * -----
 * Copyright (c) 2020 AdBase, Inc.
 */

const PipelineOverview = () =>
  import(
    /* webpackChunkName: "Pipeline" */ 'src/components/Dashboard/Views/Contacts/Companies/PipelineOverview.vue'
  );

//
export const pipelineRoutes = [
  {
    path: 'pipeline',
    name: 'Pipeline',
    component: PipelineOverview
  }
];
